import { render, staticRenderFns } from "./SupplementList.vue?vue&type=template&id=3dc6f7f2&scoped=true&"
import script from "./SupplementList.vue?vue&type=script&lang=js&"
export * from "./SupplementList.vue?vue&type=script&lang=js&"
import style0 from "./SupplementList.vue?vue&type=style&index=0&id=3dc6f7f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc6f7f2",
  null
  
)

export default component.exports